import { render, staticRenderFns } from "./BtExportChild.vue?vue&type=template&id=22dc049c&scoped=true&"
import script from "./BtExportChild.vue?vue&type=script&lang=js&"
export * from "./BtExportChild.vue?vue&type=script&lang=js&"
import style0 from "./BtExportChild.vue?vue&type=style&index=0&id=22dc049c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dc049c",
  null
  
)

export default component.exports